<template>
    <div class="box">
      <div class="text text-gray">捐助機構</div>
      <img  class="img" src="/assets/image/donate.png" />
    </div>

</template>

<script>

export default {
  name: "LaunchDonate",
}
</script>

<style scoped>
.box{
  text-align: center;
}

.img {
  height: 60%;
  margin-top: 1vh;
}

.text {
  text-align: center;
  font-size: var(--ecs-font-sm);
  font-family: SimHei;
}
</style>
